import * as React from 'react';
import { observer, inject } from 'mobx-react';
import {
  Panel, PageHeader, ListGroup, ListGroupItem, Button
} from 'react-bootstrap';
import LoggedinUser from '../../models/LoggedinUser';
import Footer from '../../components/footer/Footer';
import { getNoBrand } from '../../index';

//css
const balancesStyle = require('./balances.css');


interface Props {
  loggedinUser: typeof LoggedinUser.Type;
}

@observer
export default class Balances extends React.Component<{ loggedinUser: typeof LoggedinUser.Type }> {

  render() {

    const imageStyle = {
      width: '100%',
      height: 'auto',
      background: 'cover'
    };

    // images:
    const imgPageBanner = require('../../images/imageBannerBlue1000x120.png');
    const imgCalls = require('../../images/callDarkBlue32x32.png');
    const imgSMS = require('../../images/messageDarkBlue32x32.png');
    const imgMMS = require('../../images/messageDarkBlue32x32.png');
    const imgSurf = require('../../images/wwwDarkBlue32x32.png');

    const noBrand = getNoBrand();

    // We need to check that we have subscriptions
    if (this.props.loggedinUser.subscriptions.items.length === 0) {
      return (
        <div className="wrapper_div">
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <div className="pageBanner">
                  <h2>Saldon</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="wrapper_div">
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <div className="pageBanner">
                  <h2>Saldon</h2>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-xs-12">
                <div className="subscriptionNameAndNumber">{noBrand ? ('Din mobil'):(this.props.loggedinUser.subscriptions.selectedSubscription.name)} - {this.props.loggedinUser.subscriptions.selectedSubscription.number}</div>
              </div>
            </div>
            <h6 className="balance_subscrperiod">Registrerat för perioden {this.props.loggedinUser.subscriptions.selectedSubscription.callsAmount.period}</h6>
            <h6 className="balance_data_update">Data uppdateras minst en gång per dygn.</h6>
            {/* the grid with all icons and text about the account */}
            <div className="balance_grid">
              <div className="balance_calls_box">
                <img src={imgCalls} />
                <span>Samtal {this.props.loggedinUser.subscriptions.selectedSubscription.callsAmount.madeNationalCalls} st</span>
                <span> / samtalstid {this.props.loggedinUser.subscriptions.selectedSubscription.callsAmount.nationalCallTime}</span>
              </div>
              <div className="balance_SMS_box">
                <img src={imgSMS} /><span>SMS {this.props.loggedinUser.subscriptions.selectedSubscription.msgAmount.sentSMS} st</span>
              </div>
              <div className="balance_MMS_box">
                <img src={imgMMS} /><span>MMS {this.props.loggedinUser.subscriptions.selectedSubscription.msgAmount.sentMMS} st</span>
              </div>
              <div className="balance_surf_box">
                <img src={imgSurf} /><span>Surf {this.props.loggedinUser.subscriptions.selectedSubscription.surfAmount.usedDataTwoDecimalString} GB av {this.props.loggedinUser.subscriptions.selectedSubscription.surfAmount.initData} GB</span>
              </div>
            </div>
            {/* <div className="balance_payservices_abroad_grid">
          <div className="balance_payservices_box">
            <div className="payServices_headline">Betaltjänster</div>
            <h6>samtal ? st</h6>
            <h6>samtalskostnad ?</h6>
          </div>
          <div className="balance_abroad_box">
            <div className="abroad_headline">Utomlands</div>
            <h6>samtal {this.props.loggedinUser.subscriptions.selectedSubscription.callsAmount.madeInternationalCalls} st</h6>
            <h6>samtalstid {this.props.loggedinUser.subscriptions.selectedSubscription.callsAmount.internationalCallTime}</h6>
          </div>
        </div> */}
            {/* one last grid box for the button */}
            <div className="balance_button_grid">
              <div className="balance_callSpecButton_box">
              </div>
            </div>
          </div >
          <div className="footerDiv">
            <Footer loggedinUser={this.props.loggedinUser} />
          </div>
        </div>
      );
    }
  }
}




// WEBPACK FOOTER //
// ./src/pages/balances/Balances.tsx